export const SenderName = " K Ō Z Ē  Support"
export const SenderEmailTo = "jeffery.khoury@kozechalets.ca"
export const SenderEmail = "jeffery.khoury@kozechalets.ca"
export const SenderEmailcustomer = "customerservice@kozechalets.ca"
export const SenderEmailcustomerTo = "customerservice@kozechalets.ca"
export const CCEmail = "kimberly.eid@kozechalets.ca"